<!-- desktop template -->
<div *appIsDesktop class="toggle-container">
  <ds-button icon="refresh" size="medium" type="tertiary" variant="icon-only" iconStyle="material-icons-outlined" 
    (onClick)="refreshAtp()" [isDisabled]="disabled || refreshingAtp || !productCount">
  </ds-button>
</div>

<!-- mobile template -->
<div *appIsMobile>
  <ds-button icon="refresh" size="medium" type="secondary" variant="icon-only" iconStyle="material-icons-outlined" 
    (onClick)="refreshAtp()" [isDisabled]="disabled || refreshingAtp || !productCount">
  </ds-button>
</div>